import { jsx as o } from "react/jsx-runtime";
import { forwardRef as t } from "react";
const i = (r, e) => /* @__PURE__ */ o("svg", { viewBox: "0 0 24 24", width: "1.2em", height: "1.2em", ref: e, ...r, children: /* @__PURE__ */ o("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "m9 18l6-6l-6-6" }) }), s = t(i);
export {
  s as default
};
//# sourceMappingURL=chevron-right.js.map
